// extracted by mini-css-extract-plugin
export default {"ocean":"Wave_ocean__WRSTB","wave":"Wave_wave__6D45z","swell":"Wave_swell__F5VKt"};